var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.indicator_type)?_c('i',{staticClass:"fa fa-circle m-0",class:_vm.indicatorClass}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }